import React from "react";
import { Link } from 'react-router-dom';
import Logo from "./assets/logo1.svg";
import TwitterIcon from "./assets/twitter.svg";
import LinkedinIcon from "./assets/linkedin1.svg";

export default function Footer() {
    const currentYear = new Date().getFullYear();

    const company = {
        productName: 'Kaeros',
        legalName: 'Kaeros',
        address: '1338 Wellington St. W, Unit 10, Ottawa, Ontario, K1Y 3B7, Canada',
    };

    const socialLinks = [
        {
            key: 'x',
            href: 'https://x.com/getkaeros',
            icon: TwitterIcon,
            alt: 'X',
        },
        // Leave Discord disabled until an official profile is confirmed.
        {
            key: 'linkedin',
            href: 'https://www.linkedin.com/company/kaeros',
            icon: LinkedinIcon,
            alt: 'LinkedIn',
        },
    ];

    return (
        <footer className="bg-gray-50 border-t border-gray-200">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 md:py-10 flex flex-col md:flex-row items-center md:items-start justify-between gap-6">

                {/* Left Section - Logo and Company Info */}
                <div className="flex flex-col items-center md:items-start gap-2">
                    {/* Logo */}
                    <img src={Logo} alt={`${company.productName} logo`} className="h-8 mb-2" />

                    {/* Company Info */}
                    <div className="text-center md:text-left">
                        <p className="text-sm text-gray-600">
                            © {currentYear} {company.legalName}. All rights reserved.
                        </p>
                        <p className="text-xs text-gray-500">
                            {company.legalName} - {company.address}
                        </p>
                    </div>
                </div>

                {/* Right Section - Social Icons + Links */}
                <div className="flex flex-col items-center md:items-end gap-4">
                    {/* Social Icons */}
                    <div className="flex items-center gap-3">
                        {socialLinks.map((item) => (
                            <a
                                key={item.key}
                                href={item.href}
                                target="_blank"
                                rel="noreferrer"
                                aria-label={item.alt}
                                className="w-8 h-8 flex items-center justify-center rounded-md border bg-white hover:bg-gray-100 hover:border-gray-300 transition"
                            >
                                <img src={item.icon} alt={item.alt} className="w-4 h-4" />
                            </a>
                        ))}
                    </div>

                    {/* Footer Links */}
                    <div className="flex flex-col sm:flex-row items-center gap-3 sm:gap-6 text-sm text-gray-700">
                        <Link to="/terms" className="hover:text-black transition-colors">Terms</Link>
                        <Link to="/privacy" className="hover:text-black transition-colors">Privacy</Link>
                        <Link to="/integrations" className="hover:text-black transition-colors">Documentation</Link>
                    </div>
                </div>
            </div>
        </footer>
    );
}
